module.exports = __webpack_public_path__ + "static/img/ground8.049857bf.png";